import { endpoints } from 'services/endpoints';
import request from 'services/request';
import { paramsToFormData } from 'utils/utils';

export default {
  postOutsourcingList: (params: ProjectListReqDto): Promise<CommonListResDto> =>
    request({
      url: endpoints.outsourcing.list,
      method: 'post',
      data: paramsToFormData(params),
    }),   
    
  postOutsourcingStatus: (params: OutsourcingStatusReqDto): Promise<CommonResDto> =>
    request({
      url: endpoints.outsourcing.status,
      method: 'post',
      data: paramsToFormData(params),
    }),     
};
